import React, {FC} from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import {RequesterCaseCommentsTypes} from 'appRedux/actions/comments/types';

import TextWithMentions from 'components/Comments/TextWithMentions';
import TextWithLineBreaks from 'components/Comments/TextWithLineBreaks';

import {convertDateToCurrentLocale} from 'helpers/dateTimeConvertingHelper';

import {theme} from 'config/theme';

interface CommentRowType {
    item: RequesterCaseCommentsTypes;
    inRightPanel?: boolean;
}

const CommentRow: FC<CommentRowType> = ({item, inRightPanel}) => {
    const {section, text, dateAndTime} = item;

    const isLineBreakPresented = text.includes('\n');

    return (
        <Box sx={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start'}}>
            <Box
                sx={{
                    width: '100%',
                    backgroundColor:
                        section || inRightPanel ? `rgba(34, 34, 34, 0.05)` : theme.palette.background.default,
                    borderRadius: 2,
                    mb: 2,
                    p: 2,
                    pt: 1,
                    pb: 1,
                }}
            >
                {isLineBreakPresented ? (
                    <TextWithLineBreaks text={text} forClient />
                ) : (
                    <TextWithMentions text={text} forClient />
                )}
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        mt: 1,
                    }}
                >
                    <Typography sx={{fontWeight: 600, fontSize: 12, mr: 1}}>
                        {convertDateToCurrentLocale(dateAndTime)}
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default CommentRow;
